/** The action needs the cloud (or a manager) and cannot be done on the till alone. */
export class OfflineRefusal extends Error {
  constructor(
    readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'OfflineRefusal';
  }
}
